module.exports = __webpack_public_path__ + "img/icon.e16e1c3b.png";